<div [@loadedFadeAnimation]="'visible'" class="header__seat">
  <nav class="navbar navbar-expand-lg px-0 py-2 py-md-3">
    <div class="container">
      <a class="navbar-brand" href="https://www.seat.es/">
        <img class="logo-seat" src="../../../../assets/images/seat-s-logo.svg" width="36px" alt="SEAT">
      </a>
      <ul class="navbar-nav mt-1">
        <li class="nav-item"><a class="nav-link" href="https://www.seat.es/">Sitio web SEAT</a></li>
      </ul>
    </div>
  </nav>
</div>
<div [@loadedFadeAnimation]="'visible'" class="header_calculator">
  <div *ngIf="header=='comun'" class="header_bg">
    <div class="cont_header">
    <div class="cont_main_title bg-black-25">
        <h1 class="header_title">
          Calcula tu<br> mantenimiento.
        </h1>
    </div>
    </div>
  </div>

  <div class="subheader_calculator bg-arona-pa-1">
    <div class="container">
      <ng-container *ngIf="header=='comun'">
        <h2>Solo lo que tu SEAT necesita.</h2>
        <p class="description">Evita imprevistos al máximo. Utilizando la Calculadora de Mantenimientos, sabrás qué operaciones necesita tu automóvil, cuál es su presupuesto aproximado, y podrás pedir cita cuando quieras.
        </p>
      </ng-container>
      <div class="d-flex justify-content-between" *ngIf="header=='cookies'">
        <h2>Política de cookies</h2>
        <a class="btn btn-secondary" href="/">Volver</a>
      </div>
    </div>
    <a id="content-starts"></a>
  </div>
</div>